var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/img/GettingStarted.jsx";

import React from 'react';
import PropTypes from 'prop-types';

var GettingStarted = function GettingStarted(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "50",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("style", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 9
    }
  }, '.prefix__st0{fill:#001751}.prefix__st2{fill:#8d5514}.prefix__st3{fill:#0d4599}.prefix__st5{fill:#fff}'), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_2_1_",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Layer_1-2",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M49.1 64.6c-.1.1-.1.4 0 .5l4.5 4.1c.1.1.1.2.1.3 0 .1 0 .2-.1.3l-4 3.3c-.2.1-.2.4 0 .5l11 9.9c.1.1.3.1.5 0l11-9.9c.1-.2.1-.4 0-.5l-4-3.3c-.1-.1-.1-.2-.1-.3 0-.1 0-.2.1-.3l4.5-4.1c.1-.1.1-.4 0-.5l-3.7-4 .5 4.2c.1.4-.2.8-.7.9-.2 0-.4 0-.5-.1L65.9 64l-5.1 15.2-5.5-14.9-1.9 1.2c-.4.2-.8.1-1.1-.2-.1-.2-.1-.3-.1-.5l.5-4.2-3.6 4z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M73.7 64.9c0 .1-.1.2-.1.3l-4.4 4c-.2.1-.2.4 0 .5l4 3.3c.1.1.1.2.1.3 0 .1 0 .2-.1.3l-12.3 11h-.1l-12.3-11c-.1-.1-.1-.2-.1-.3 0-.1 0-.2.1-.3l4-3.3c.2-.1.2-.4 0-.5l-4.4-4c-.1-.1-.1-.2-.1-.3 0-.1 0-.2.1-.3l4.8-5.2v-.1c-4 1.5-8.6 2.4-12.3 4.1-3.2.7-5.8 3.2-6.7 6.3-.2.5-.3.9-.4 1.4l-3.9 13.4c17.2 11.8 40.8 7.4 52.6-9.8 1.5-2.3 2.8-4.7 3.9-7.2-.1-.1-.2-.3-.3-.4-.9-1.1-2-2-3.2-2.6-3.7-2.1-8.7-3.1-13.2-4.6l4.4 4.8c-.2 0-.1.1-.1.2z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6 41.8c.7-.9 2-1.9 2.3-4.2s.7-4.7.7-4.7c1.3-8.6 8.6-14 16.3-12.8s13 8.2 11.7 16.9c-.8 5.3-4.4 6.5-6.4 10.8-1.2 2.9-1.1 7.5-.7 11.3S62 63.9 58 63.9l-.7-.1c-2.6 0-3.6-1.2-2.8-5.2l.2-1.2c.6-3.1-1.4-3.3-2.7-3.5l-3-.6c-2-.3-3.4-1.4-3.3-4.5v-3.6c0-.7-.5-1.4-1.2-1.5h-.1c-.6 0-1.1-.6-1.1-1.2 0-.3.1-.5.3-.7z",
    fill: "#c4903f",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__st2",
    d: "M58.4 53.3c.2-.3.5-.6.7-.9.2-.3.4-.7.5-1 .1-.3 0-.6-.3-.7-.3-.1-.6 0-.7.2-.2.3-.3.5-.5.7l-.7.7c-.5.4-1 .7-1.5 1-.6.3-1.1.5-1.7.6-.2.1-.5.1-.7.1.8.2 1.5.9 1.5 1.7.6-.3 1.2-.6 1.8-1 .5-.4 1.1-.9 1.6-1.4zM46.9 43.9l-2.6-.2h-.1H44.5c.5.1 1 .5 1.2 1l1.2-.1c.2 0 .3-.2.3-.4-.1-.2-.2-.3-.3-.3zM64.9 39.6h-.5c-.1 0-.3 0-.4.1-.3.1-.5.2-.8.4-.4.3-.8.8-1 1.3-.1.2-.2.5-.3.7 0 .2-.1.5-.1.7v.7c0 .2.1.5.1.7.1.3.4.5.7.4.2 0 .4-.2.4-.4v-.1c.1-.2.1-.4.2-.6 0-.2.1-.4.1-.6l.2-.5c.1-.2.1-.3.2-.5.1-.3.3-.6.5-.8l.3-.3c.1 0 .1-.1.2-.1h.2c.3 0 .6-.3.6-.6 0-.2-.3-.4-.6-.5z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__st3",
    d: "M41.3 27.8c.5-2.1 2.3-3.6 4.5-3.7-2.7-1.1-4.3-5-2.6-7.5 1.4-2 4.3-2.4 6.4-1.4-1-2.1-.8-4.5.5-6.4 2.1-2.7 6.2-3.5 9.4-2.2 3.2 1.4 5.7 4 7.1 7.2 1 2.4 1.7 4.8 2.2 7.3.1-1.9 1-3.6 2.5-4.7 4.8-3.4 9.1.7 9.5 5.4.4 5.1-1.8 10.1-5.9 13.2 3.7-1.6 8.5 1.4 8.7 5.4s-4.4 7.4-8.2 6.1c2.8 1.9 1.5 7-1.8 8s-6.9-1.5-8.1-4.7-.6-6.8.7-10c-2.4 1.9-5.8 1.5-7.7-.8-1.7-2.4-1.2-5.8 1.2-7.6-2.2 1.5-4.6 2.8-7.2 3.6-2.6.9-5.4.7-7.9-.5-2.3-1.2-3.7-3.9-3.3-6.7z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8 79.2L65.9 64l-4.6-3c-.3-.2-.6-.2-.8 0l-5.1 3.3 5.4 14.9z",
    fill: "#e0f2ff",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__st3",
    d: "M68.9 60.7l3.6 3.9c.1.1.1.4 0 .5L68 69.2c-.1.1-.1.2-.1.3 0 .1 0 .2.1.3l4 3.3c.2.1.2.4 0 .5l-11 9.9c-.1.1-.3.1-.4 0l-11-9.9c-.2-.1-.2-.4 0-.5l4-3.3c.1-.1.1-.2.1-.3 0-.1 0-.2-.1-.3l-4.5-4.1c-.1-.1-.1-.4 0-.5l3.7-4 .1-1.2-4.9 5.2c-.1.1-.1.2-.1.3 0 .1 0 .2.1.3l4.4 4c.2.1.2.4 0 .5l-4 3.3c-.1.1-.1.2-.1.3 0 .1 0 .2.1.3l12.3 11h.1l12.3-11c.1-.1.1-.2.1-.3 0-.1 0-.2-.1-.3l-4-3.3c-.2-.1-.2-.4 0-.5l4.4-4c.1-.1.1-.2.1-.3 0-.1 0-.2-.1-.3l-4.4-4.8-.5-.5.3 1.4z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__st5",
    d: "M52.9 59.4l-.2 1.2-.5 4.2c-.1.4.2.8.7.9.2 0 .4 0 .5-.1l1.9-1.2 5.1-3.3c.3-.2.6-.2.8 0l4.6 3 2.3 1.5c.4.2.8.1 1.1-.2.1-.2.1-.3.1-.5l-.5-4.2-.2-1.2-.4-3.2c0-.3-.3-.4-.5-.4-.1 0-.1 0-.2.1l-.4.3-5.9 3.7c-.3.2-.6.2-.9 0l-5.4-3.6-.9-.6c-.2-.1-.5-.1-.7.1 0 .1-.1.1-.1.2l-.3 2v1.3z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 48,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.3,
    cy: 33.3,
    r: 12.4,
    fill: "#006aff",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__st5",
    d: "M21 38.7l-3.4-3.4c-.5-.5-.5-1.3 0-1.7.5-.5 1.3-.5 1.8 0l2.6 2.6 7.2-7.2c.5-.5 1.3-.5 1.8 0s.5 1.3 0 1.8l-8.1 8.1c-.6.3-1.4.3-1.9-.2z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h100v100H0z",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 17
    }
  }))));
};

GettingStarted.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};
GettingStarted.defaultProps = {
  className: null
};
export default GettingStarted;